import { Flex } from '@chakra-ui/react';

interface IChangeSizeProps {
	fontSize: number;
	setFontSize: (v: number) => void;
	spacing: number;
	setSpacing: (v: number) => void;
}
export const ChangeSpacing = ({
	spacing,
	fontSize,
	setFontSize,
	setSpacing,
}: IChangeSizeProps) => {
	return (
		<Flex
			alignItems={'center'}
			gap={'8px'}
		>
			<div
				style={{
					display: 'flex',
					alignItems: 'center',
					gap: 8,
				}}
			>
				<span>Tamanho da fonte:</span>
				<input
					type='range'
					min={8}
					max={24}
					step={1}
					value={fontSize}
					onChange={e => setFontSize(Number(e.target.value))}
					style={{ width: 80, accentColor: '#3182CE' }}
				/>
				<span>{fontSize}px</span>
			</div>
			<div
				style={{
					display: 'flex',
					alignItems: 'center',
					gap: 8,
				}}
			>
				<span>Espaçamento:</span>
				<input
					type='range'
					min={1}
					max={15}
					step={1}
					value={spacing}
					onChange={e => setSpacing(Number(e.target.value))}
					style={{ width: 80, accentColor: '#3182CE' }}
				/>
				<span>{spacing}px</span>
			</div>
		</Flex>
	);
};
